module.exports = "/_next/static/images/gu-c3db56a6be8a231a703070535cb94874.svg";